import { createFinanceViewService } from '@saas-foundation/shared-frontend/financeView';
import { getServiceApiUrl } from '../utils/constants';
import { normalizeReportingPeriod } from '../utils/reportingPeriod';

export const financeViewService = createFinanceViewService({
  getServiceApiUrl,
  normalizeReportingPeriod,
  consumerService: 'agenticrcm',
});
